import { render, staticRenderFns } from "./ActiveTrials.vue?vue&type=template&id=79bf0eed&"
import script from "./ActiveTrials.vue?vue&type=script&lang=js&"
export * from "./ActiveTrials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports